/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async fetchProfitLoss(data) {
    return await apiCall("transaction/statistics/profit_loss", data);
  },
  async fetchTopExpenses(data){
    return await apiCall("transaction/statistics/expense_stat", data);
  },
  async fetchNetWorth(data){
    return await apiCall("transaction/statistics/business_net_worth", data);
  },
  async fetchCreditorInvoicing(data){
    return await apiCall("transaction/statistics/creditor_invoicing_stat", data);
  },
  async fetchProjectStatList(data){
    return await apiCall("tag/project/project_stat_list", data);
  },

};
